/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import classes from './index.module.css';
import ApplicationLayout from '../Layout';

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (children)}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
}

export default function GDDApplication() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabStyle = {};
  return (
    <ApplicationLayout type="gdd">
      <div className={classes.container}>
        <div className={classes.header}>Turn late deliveries into repeat customers</div>
        <div className={classes.label}>Free for merchants</div>
        <Tabs
          sx={{
            '& .MuiTabs-indicator': {
              backgroundColor: '#645AFF',
              height: '4px',
              borderRadius: '4px 4px 0 0',
            },
            '& .MuiButtonBase-root': {
              textTransform: 'none',
              fontWeight: 400,
              color: '#1E2022',
            },
            '& .Mui-selected.MuiButtonBase-root': {
              color: '#1E2022',
            },
          }}
          value={value}
          onChange={handleChange}
          aria-label="Guaranteed Delivery Date"
        >
          <Tab style={tabStyle} label="At checkout" {...a11yProps(0)} />
          <Tab style={tabStyle} label="When deliveries are late" {...a11yProps(1)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <ul className={classes.tab_content_ul}>
            <li className={classes.tab_content_li}>Shoppers will see a new shipping method with Guaranteed Delivery Date</li>
            <li className={classes.tab_content_li}>The shipping cost includes a $2 insurance premium against late deliveries</li>
            <li className={classes.tab_content_li}>Process the order like any other ones, using your most commonly selected shipping method</li>
          </ul>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ul className={classes.tab_content_ul}>
            <li className={classes.tab_content_li}>Seel will send shoppers partial or full refunds if their orders are late</li>
            <li className={classes.tab_content_li}>Refunds will be sent as prepaid Visa cards to their email</li>
            <li className={classes.tab_content_li}>Reduce customer complaints and drive repeat purchases</li>
          </ul>
        </TabPanel>
        <div className={classes.bottom_buttons}>
          <Link to="/"><div className={classes.button}>Back to home</div></Link>
          <Link to="./review"><div className={cx([classes.button], [classes.button_next])}>Next →</div></Link>
        </div>
      </div>
    </ApplicationLayout>

  );
}
